// SVG de balão/aspas
const QuoteIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
    <path d="M10 7H6a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l-1 3h2l1-3V8a1 1 0 0 0-1-1zM19 7h-4a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h3l-1 3h2l1-3V8a1 1 0 0 0-1-1z" />
  </svg>
);

export default function WeeklyPrompt({ prompt }) {
  if (!prompt) return null;

  return (
    <div className="weekly-prompt">
      <div className="weekly-prompt-label">
        <QuoteIcon />
        Prompt da semana
      </div>
      <p className="weekly-prompt-text">"{prompt.prompt_text}"</p>
    </div>
  );
}
